import axios, { AxiosResponse } from 'axios';

/**
 * Получение ссылки изображения по тоукену
 */
export const getImgUrl = (id: string, context?: string): Promise<AxiosResponse<string>> => {
    return axios.get<string>('/ru/_/service/isnareactcms/helper', {
        params: {
            id,
            action: 'image',
            context,
        }
    });
};

/**
 * Получение списка меню
 */
export const getMenuList = (context): Promise<AxiosResponse> => {
    return axios.get('/ru/_/service/isnareactcms/helper', {
        params: {
            action: 'top-menu',
            context
        }
    });
};

/**
 * Получение списка внешних ресурсов
 */
export const getExtResList = (language: string, context: string): Promise<AxiosResponse> => {
    return axios.get('/ru/_/service/isnareactcms/helper', {
        params: {
            action: 'ext-res',
            language,
            context
        }
    });
};
